export default __webpack_public_path__ + "static/media/user.7f853ccb.svg";